// UAT7-T6-RELOAD-SISA-01 (22 Sep 2026) — jejak diagnostik saat pengguna DILEMPAR
// ke /login. Sekali pada UAT sesi 7 seseorang terlempar padahal sesinya valid;
// kejadian KEDUA butuh tempat berlabuh: jam, halaman asal, ada/tidaknya kunci
// sesi Supabase di localStorage, dan apakah URL memuat hash OAuth. Tanpa itu ia
// tidak bisa dibedakan dari kegagalan jaringan biasa.
//
// Yang disimpan hanya NAMA kunci dan boolean — tidak pernah isi token.
// Disimpan di localStorage (kunci `etams_lempar_login_diag`, maksimal 5 jejak
// terakhir) supaya Owner/agent bisa membacanya dari DevTools sesudah kejadian.

export const KUNCI_DIAG = "etams_lempar_login_diag";
export const MAKS_JEJAK = 5;

/** Susun satu jejak dari keadaan yang diberikan (murni — bisa diuji tanpa DOM). */
export function susunJejak({ dari, hash, kunci, session, profile, whitelistError, sekarang }) {
  const namaKunci = (kunci || []).filter((k) => typeof k === "string" && k.startsWith("sb-"));
  return {
    waktu: (sekarang || new Date()).toISOString(),
    dari: dari || "",
    hashOAuth: Boolean(hash && /access_token|refresh_token|code=/.test(hash)),
    kunciSesiSupabase: namaKunci,          // nama kunci saja, bukan isinya
    adaSession: Boolean(session),
    adaProfile: Boolean(profile),
    whitelistError: Boolean(whitelistError),
  };
}

/** Tambahkan jejak ke daftar lama; daftar dipangkas ke MAKS_JEJAK terakhir. */
export function tambahJejak(daftarLama, jejak) {
  const daftar = Array.isArray(daftarLama) ? daftarLama.slice() : [];
  daftar.push(jejak);
  return daftar.slice(-MAKS_JEJAK);
}

/** Catat ke localStorage. Gagal-diam: diagnostik tidak boleh mematahkan navigasi. */
export function catatLemparLogin({ session, profile, whitelistError }) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    const ls = window.localStorage;
    const kunci = [];
    for (let i = 0; i < ls.length; i += 1) kunci.push(ls.key(i));
    const jejak = susunJejak({
      dari: window.location ? window.location.pathname : "",
      hash: window.location ? window.location.hash : "",
      kunci, session, profile, whitelistError,
    });
    let lama = [];
    try { lama = JSON.parse(ls.getItem(KUNCI_DIAG) || "[]"); } catch (_) { lama = []; }
    ls.setItem(KUNCI_DIAG, JSON.stringify(tambahJejak(lama, jejak)));
    return jejak;
  } catch (_) {
    return null;
  }
}
